import React from 'react';
import Table from '../common/Table';
import { InvoiceItemDTO } from '../../services/apiClient';

interface InvoiceItemTableProps {
  data: InvoiceItemDTO[];
  onEdit: (row: InvoiceItemDTO) => void;
  onDelete: (row: InvoiceItemDTO) => void;
  isLoading: boolean;
}

const InvoiceItemTable: React.FC<InvoiceItemTableProps> = ({
  data,
  onEdit,
  onDelete,
  isLoading
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Description',
          key: 'description',
        },
        {
          label: 'Quantity',
          key: 'quantity',
          format: (value: number) => value.toString(),
          width: '120px',
        },
        {
          label: 'Rate',
          key: 'rate',
          format: (value: number) => `R ${value.toFixed(2)}`,
          width: '120px',
        },
        {
          label: 'Amount',
          key: 'amount',
          format: (value: number) => `R ${value.toFixed(2)}`,
          width: '120px',
        },
      ]}
      data={data}
      actions={{
        onEdit,
        onDelete,
      }}
      isLoading={isLoading}
      allowPaging={false}
    />
  );
};

export default InvoiceItemTable;